module.exports = __webpack_public_path__ + "static/media/PrivateHookah_3_t.428d0eb2.jpg";